import { useAuth } from '../../contexts/auth';
import CFIDashboard from '../../features/cfi/cfi-dashboard/components/CFIDashboard';
import DealerDashboard from '../../features/dealer/dealer-dashboard/components/DealerDashboard';
import DistributorDashboard from '../../features/distributor/dashboard/components/DistributorDashboard';
import ServiceProviderDashboard from '../../features/service-provider/dashboard/components/ServiceProviderDashboard';
import { CompanyTypes } from '../../types/enums';
import './home.scss';

export default function HomePage() {

	const { user } = useAuth();

	if (user?.companyTypeId === CompanyTypes.CFI)
		return (<CFIDashboard></CFIDashboard>);

	if (user?.companyTypeId === CompanyTypes.DEALER)
		return (<DealerDashboard></DealerDashboard>);

	if (user?.companyTypeId === CompanyTypes.DISTRIBUTOR ||
		user?.companyTypeId === CompanyTypes.MFR)
		return (<DistributorDashboard></DistributorDashboard>);

	if (user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER) {
		return (<ServiceProviderDashboard></ServiceProviderDashboard>);
	}

	return (
		<>
		</>
	)
}
